import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';

export type EmailDocumentDraftsLoadState = 'empty' | 'error' | 'loading';

interface EmailDocumentDraftsStatusProps {
  noEmailsLabel: string;
  onRetry: () => void;
  state: EmailDocumentDraftsLoadState;
}

export default function EmailDocumentDraftsStatus({
  noEmailsLabel,
  onRetry,
  state,
}: EmailDocumentDraftsStatusProps) {
  switch (state) {
    // The request's error toast already explains what failed.
    case 'error':
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <SmallButton onClick={() => onRetry()} variant="outlined">
            {t('actions.retry')}
          </SmallButton>
        </Box>
      );
    case 'empty':
      return (
        <Typography variant="body2" sx={{ color: 'text.secondary', py: 2 }}>
          {noEmailsLabel}
        </Typography>
      );
    case 'loading':
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress aria-label={t('common.loading')} />
        </Box>
      );
    default:
      throw new Error(`Unsupported email drafts state: ${state satisfies never}`);
  }
}
